const available = () => getEditor()

const fire = maybeRun('fire')

const getContent = maybeRun('getContent')

const focus = maybeRun('focus')

const insertContent = (content, options) => {
  const editor = getEditor()
  if (!editor) return false
  const result = editor.insertContent(content)
  if (options && options.focus) editor.focus()
  return result
}

const setContent = (content, options) => {
  const editor = getEditor()
  if (!editor) return false
  const result = editor.setContent(content)
  if (options && options.focus) editor.focus()
  return result
}

function getEditor() {
  const tiny = getTiny()
  if (!tiny) return undefined
  return tiny.activeEditor
}

function getTiny() {
  if (typeof window === 'undefined') return undefined
  return window.tinyMCE
}

function maybeRun(fnName) {
  return (...args) => {
    const editor = getEditor()
    if (!editor) return false
    return editor[fnName](...args)
  }
}

export default {
  fire,
  available,
  getContent,
  insertContent,
  setContent,
  focus,
  getEditor,
}
